module.exports = __webpack_public_path__ + "static/img/cwi.4e03d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/cwi.jpg
// module id = 2rx4
// module chunks = 1